import { defineWebModule, lazyPage } from "@signet/web-kit";
import { SwapIcon } from "./icon.tsx";
import "./swaps.css";

// Loaded when first opened (web-kit lazy.ts).
const SourcesPage = lazyPage(() => import("./sources.tsx"), "SourcesPage");
const CreatePage = lazyPage(() => import("./create.tsx"), "CreatePage");
const ProcessingPage = lazyPage(() => import("./processing.tsx"), "ProcessingPage");
const ReviewPage = lazyPage(() => import("./review.tsx"), "ReviewPage");
const ApprovedPage = lazyPage(() => import("./approved.tsx"), "ApprovedPage");

/* ──────────────────────────────────────────────────────────────────────────
   The web half of Swaps: five tabs, one per step a VA takes. Sources and
   Review are decks (drag or arrow keys), Create pairs a creator with videos,
   Processing shows what is running, Approved lists what made it. A preview
   on sample data until the pipeline behind it is built.
   ────────────────────────────────────────────────────────────────────────── */

const needs = "swaps.swap:view";

export default defineWebModule({
  id: "swaps",
  nav: { label: "Swaps", icon: SwapIcon, to: "/swaps", needs },
  routes: [
    { path: "/swaps", component: SourcesPage, needs },
    { path: "/swaps/create", component: CreatePage, needs },
    { path: "/swaps/processing", component: ProcessingPage, needs },
    { path: "/swaps/review", component: ReviewPage, needs },
    { path: "/swaps/approved", component: ApprovedPage, needs },
  ],
  commands: [
    { id: "swaps.sources", label: "Approve source videos", to: "/swaps", needs, hint: "Swaps", keywords: "swipe scraped videos keep reject" },
    { id: "swaps.create", label: "Create swaps", to: "/swaps/create", needs, hint: "Swaps", keywords: "face swap creator photo mulerouter" },
    { id: "swaps.processing", label: "Swaps processing", to: "/swaps/processing", needs, hint: "Swaps", keywords: "running progress queue" },
    { id: "swaps.review", label: "Review swaps", to: "/swaps/review", needs, hint: "Swaps", keywords: "approve finished videos" },
    { id: "swaps.approved", label: "Approved swaps", to: "/swaps/approved", needs, hint: "Swaps", keywords: "drive cost done" },
  ],
});
